import React, { useRef } from 'react';
import SignaturePadComponent from '../components/SignaturePadComponent';

const SignaturePreview = () => {
  const sigRef1 = useRef();
  const sigRef2 = useRef();

  const clearBoth = () => {
    sigRef1.current.signaturePad.clear();
    sigRef2.current.signaturePad.clear();
  };

  const clearFirst = () => {
    sigRef1.current.signaturePad.clear();
  };

  const clearSecond = () => {
    sigRef2.current.signaturePad.clear();
  };

  const save = () => {
    const dataURL1 = sigRef1.current.signaturePad.toDataURL();
    const dataURL2 = sigRef2.current.signaturePad.toDataURL();
    console.log("Saved Signature 1:", dataURL1);
    console.log("Saved Signature 2:", dataURL2);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "40px" }}>
      <h2>Preview Signature Pads</h2>

      <div style={{ marginBottom: "30px" }}>
        <h3>Signature Pad Initials</h3>
        <SignaturePadComponent ref={sigRef1} />
      </div>


      <h3>Initials</h3>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '30px' }}>
        <SignaturePadComponent ref={sigRef2} width={200} height={100} />
      </div>

      <div style={{ marginTop: "20px" }}>
      <button
          onClick={clearFirst}
          style={{
            backgroundColor: "#f44336",
            color: "white",
            padding: "10px 16px",
            marginRight: "10px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          Clear First
        </button>
        <button
          onClick={clearSecond}
          style={{
            backgroundColor: "orange",
            color: "white",
            padding: "10px 16px",
            marginRight: "10px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          Clear Second
        </button>
        <button
          onClick={clearBoth}
          style={{
            backgroundColor: "purple",
            color: "white",
            padding: "10px 16px",
            marginRight: "10px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          Clear Both
        </button>
        <button
          onClick={save}
          style={{
            backgroundColor: "#4caf50",
            color: "white",
            padding: "10px 16px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          Save Both
        </button>
      </div>
    </div>
  );
};

export default SignaturePreview;